import ResourceItem from '@/components/ui/ResourceItem';
import Spacer from '@/components/ui/spacer/spacer';
import React from 'react'
import EC_Granted_NICDC_as_on_25th_July_2024 from '@/assets/pdfs/Envoirment Clearance/NICDC/EC_Granted_NICDC_as_on_25th_July_2024.pdf'
import Status_of_Environment_Clearance_granted_for_NICDC_Projects from '@/assets/pdfs/Envoirment Clearance/NICDC/Status of Environment Clearance granted for NICDC Projects.pdf'
import cn from '@/hooks/class-names';
import { resorcesClass, universalLeftRight } from '@/constants/class.config';
import CustomBreadcrumbs from '@/components/ui/header/custom-breadcrumbs';
import useFetchData from '@/hooks/use-fetch-data';

function Nicdc() {
    const { data, loading, error } = useFetchData("NICDC");

    // const data = [
    //     { "_id": 0, "languageKey": "resources.nicdc.child.01", "url": EC_Granted_NICDC_as_on_25th_July_2024, "target": "_blank", className: 'h-[75%] laptop-large:h-[65%]', },
    //     { "_id": 0, "languageKey": "resources.nicdc.child.02", "url": Status_of_Environment_Clearance_granted_for_NICDC_Projects, "target": "_blank", }
    // ]

    return (
        <div>
            <div><CustomBreadcrumbs /></div>
            <div className={cn('bg-primary ', universalLeftRight)}>
                <div className={'grid mobile:grid-cols-2 laptop:grid-cols-4 laptop-large:grid-cols-5 gap-4 laptop:gap-4 laptop-large:gap-10'}>
                    {data?.map((ele, index) => (
                        <div key={index} className="w-full flex flex-col bg-white ">
                            <ResourceItem ele={ele} className={'h-[58%]'} />
                        </div>
                    ))}
                </div>
            </div>
            <div><Spacer /></div>
        </div>
    )
}

export default Nicdc;